// Huisstijl-voorgeheugen — het portaal opent METEEN in het juiste merk.
//
// PROBLEEM. De branding (logo, favicon, merkkleuren) staat in de database en komt
// dus pas ná een netwerkronde binnen: `/api/branding/public` vóór het inloggen (op
// basis van het domein) en `/api/branding` erna (de huisstijl van de gebruiker
// zelf, inclusief de verkoopteam-laag). Tot dat antwoord er was tekende het portaal
// een merkloos eerste beeld — en op het login-scherm zelfs het platformlogo. Wie
// bij een energielabel hoort zag daardoor ongeveer een seconde het verkeerde merk
// voordat het zijne verscheen.
//
// OPLOSSING. De laatst bekende huisstijl wordt hier onthouden; de EERSTE tekening
// komt uit dit voorgeheugen en het antwoord van de server overschrijft ze daarna
// stil. Wijzigt een beheerder de branding, dan is het voorgeheugen één tekening
// oud en daarna weer gelijk — dat is de prijs voor een merkvast begin.
//
// Zelfde idee (en zelfde localStorage-idioom) als `appIconLabel` voor het
// installatie-icoon: onthouden voor de volgende start, zie public/index.html.

const MERK_KEY = 'merkCache';            // publiek merk van DIT domein (vóór login)
const GEBRUIKER_KEY = 'gebruikerMerk';   // huisstijl van de ingelogde gebruiker
const TAB_NAAM_KEY = 'tabMerkNaam';      // browsertab — gelezen in public/index.html
const TAB_ICOON_KEY = 'tabMerkIcoon';    // idem, vóór de eerste tekening

const lees = (key) => {
  try {
    const ruw = localStorage.getItem(key);
    return ruw ? JSON.parse(ruw) : null;
  } catch { return null; }   // private mode of stukke inhoud → gewoon zonder voorgeheugen
};

const schrijf = (key, waarde) => {
  try {
    if (waarde == null) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify(waarde));
  } catch { /* private mode of quotum vol (logo's zijn data-URL's) — niet erg */ }
};

// ── Merk van het domein (login-, MFA- en resetscherm + de eerste laadfase) ────
// Aan het hostname gebonden: op een ander merkdomein telt het voorgeheugen niet.
export function leesMerkCache(host) {
  const c = lees(MERK_KEY);
  return c && c.host === host ? c.merk : null;
}

export function schrijfMerkCache(host, merk) {
  schrijf(MERK_KEY, merk ? { host, merk } : null);
}

// ── Huisstijl van de ingelogde gebruiker (het dashboard zelf) ────────────────
// Aan het gebruikers-id gebonden, zodat een tweede account op hetzelfde toestel
// (of een impersonatie) nooit de huisstijl van de vorige meekrijgt.
// Retourneert `undefined` als er niets onthouden is en `null` als we wéten dat
// deze gebruiker geen eigen huisstijl heeft — dat verschil bepaalt of er nog op
// het merk van het domein teruggevallen mag worden.
export function leesGebruikerBranding(userId) {
  const c = lees(GEBRUIKER_KEY);
  if (!c || !userId || String(c.id) !== String(userId)) return undefined;
  return c.branding || null;
}

export function schrijfGebruikerBranding(userId, branding) {
  if (!userId) return;
  schrijf(GEBRUIKER_KEY, { id: String(userId), branding: branding || null });
}

// ── Browsertab (titel + favicon) ─────────────────────────────────────────────
// Wordt vóór de eerste tekening toegepast door het scriptje in public/index.html.
// Leeg meegeven wist het onthouden merk: dan hoort de platform-default er weer.
export function onthoudTabMerk(naam, favicon) {
  try {
    if (naam) localStorage.setItem(TAB_NAAM_KEY, naam); else localStorage.removeItem(TAB_NAAM_KEY);
    if (favicon) localStorage.setItem(TAB_ICOON_KEY, favicon); else localStorage.removeItem(TAB_ICOON_KEY);
  } catch { /* private mode */ }
}
